import { useState } from "react";
import { API_BASE_URL, API_ENDPOINTS } from "../../../config/apiConfig";
import "./MessageUploadModal.css";

export const MessageUploadModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    data: "",
    testo: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);

  const resetForm = () => {
    setFormData({ data: "", testo: "" });
    setUploadResult(null);
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!formData.data || !formData.testo.trim()) {
      setUploadResult({
        success: false,
        message: "Tutti i campi sono obbligatori",
      });
      return;
    }

    setIsLoading(true);
    setUploadResult(null);

    try {
      const dataFormatted = new Date(formData.data + "T00:00:00").toISOString();

      const response = await fetch(
        `${API_BASE_URL}${API_ENDPOINTS.UPLOAD_MESSAGES}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            data: dataFormatted,
            testo: formData.testo.trim(),
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      setUploadResult(result);

      if (result.success) {
        setTimeout(() => {
          resetForm();
        }, 2000);
      }
    } catch (error) {
      console.error("Errore durante l'upload:", error);
      setUploadResult({
        success: false,
        message: `Errore di connessione: ${error.message}`,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && e.ctrlKey) {
      handleSubmit();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="upload-overlay" onClick={handleClose}>
      <div className="upload-modal" onClick={(e) => e.stopPropagation()}>
        <div className="upload-header">
          <h3>📤 Caricamento Nuovo Messaggio</h3>
          <button className="upload-close" onClick={handleClose}>
            ✕
          </button>
        </div>

        <div className="upload-form" onKeyPress={handleKeyPress}>
          <div className="form-group">
            <label htmlFor="messageDate" className="form-label">
              📅 Data del Messaggio
            </label>
            <input
              type="date"
              id="messageDate"
              className="form-input date-input"
              value={formData.data}
              onChange={(e) => handleInputChange("data", e.target.value)}
              max={new Date().toISOString().split("T")[0]}
            />
            <small className="form-help">
              Seleziona la data associata al messaggio
            </small>
          </div>

          <div className="form-group">
            <label htmlFor="messageText" className="form-label">
              ✏️ Testo del Messaggio
            </label>
            <textarea
              id="messageText"
              className="form-input textarea-input"
              placeholder="Inserisci qui il contenuto del messaggio..."
              value={formData.testo}
              onChange={(e) => handleInputChange("testo", e.target.value)}
              rows={6}
            />
            <small className="form-help">
              Inserisci il contenuto completo del messaggio da caricare
              (Ctrl+Enter per inviare)
            </small>
          </div>

          {uploadResult && (
            <div
              className={`upload-result ${
                uploadResult.success ? "success" : "error"
              }`}
            >
              <div className="result-icon">
                {uploadResult.success ? "✅" : "❌"}
              </div>
              <div className="result-content">
                <div className="result-message">{uploadResult.message}</div>
                {uploadResult.success && uploadResult.filename && (
                  <div className="result-filename">
                    File creato: {uploadResult.filename}
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="upload-actions">
            <button
              type="button"
              className="btn btn-cancel"
              onClick={handleClose}
              disabled={isLoading}
            >
              Annulla
            </button>
            <button
              type="button"
              className="btn btn-submit"
              onClick={handleSubmit}
              disabled={isLoading || !formData.data || !formData.testo.trim()}
            >
              {isLoading ? (
                <>
                  <span className="loading-spinner"></span>
                  Caricamento...
                </>
              ) : (
                "📤 Carica Messaggio"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
